import React from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { default as dayjs } from 'dayjs'

export const ExamScheduleForm = ({ onSubmit, onUpdate, exm, syl, id }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const submit = (data) => {
    onSubmit(data, exm.syllabusCombinationSubjectExamId, syl)
  }

  const submitUpdate = (data) => {
    onUpdate(data, exm.examSchedule)
  }

  if (exm.examSchedule === null) {
    return (
      <form onSubmit={handleSubmit(submit)} className="trtui-row trtui-g-2">
        <div className={`trtui-col-md-3`}>
          <label className="trtui-form-label">Date</label>
          <input
            className={`trtui-form-control ${errors['examDate-' + id] && 'trtui-is-invalid'}`}
            type="date"
            id={'examDate-' + id}
            {...register('examDate-' + id, {
              required: 'Exam date is required',
            })}
          />
          {errors['examDate-' + id] && (
            <div className="trtui-invalid-feedback">{errors['examDate-' + id].message}</div>
          )}
        </div>
        <div className={`trtui-col-md-3`}>
          <label className="trtui-form-label">Start Time</label>
          <input
            className={`trtui-form-control ${errors['examStartTime-' + id] && 'trtui-is-invalid'}`}
            type="time"
            id={'examStartTime-' + id}
            {...register('examStartTime-' + id, {
              required: 'Start time is required',
            })}
          />
          {errors['examStartTime-' + id] && (
            <div className="trtui-invalid-feedback">{errors['examStartTime-' + id].message}</div>
          )}
        </div>
        <div className={`trtui-col-md-3`}>
          <label className="trtui-form-label">End Time</label>
          <input
            className={`trtui-form-control ${errors['examEndTime-' + id] && 'trtui-is-invalid'}`}
            type="time"
            id={'examEndTime-' + id}
            {...register('examEndTime-' + id, {
              required: 'End time is required',
            })}
          />
          {errors['examEndTime-' + id] && (
            <div className="trtui-invalid-feedback">{errors['examEndTime-' + id].message}</div>
          )}
        </div>
        <div className={`trtui-col-md-3`}>
          <button
            className="trtui-btn trtui-btn-success trtui-btn-icon trtui-btn-sm"
            style={{ marginTop: '2.1rem' }}
          >
            <i className="ri ri-add-line" />
          </button>
        </div>
      </form>
    )
  } else {
    return (
      <form onSubmit={handleSubmit(submitUpdate)} className="trtui-row trtui-g-2">
        <div className={`trtui-col-md-3`}>
          <label className="trtui-form-label">Date</label>
          <input
            className={`trtui-form-control ${errors['examDate-' + id] && 'trtui-is-invalid'}`}
            type="date"
            defaultValue={dayjs(exm.examSchedule?.examDate).format('YYYY-MM-DD')}
            id={'examDate-' + id}
            {...register('examDate-' + id, {
              required: 'Exam date is required',
            })}
          />
          {errors['examDate-' + id] && (
            <div className="trtui-invalid-feedback">{errors['examDate-' + id].message}</div>
          )}
        </div>
        <div className={`trtui-col-md-3`}>
          <label className="trtui-form-label">Start Time</label>
          <input
            className={`trtui-form-control ${errors['examStartTime-' + id] && 'trtui-is-invalid'}`}
            type="time"
            defaultValue={dayjs(exm.examSchedule?.examStartTime).format('HH:mm')}
            id={'examStartTime-' + id}
            {...register('examStartTime-' + id, {
              required: 'Start time is required',
            })}
          />
          {errors['examStartTime-' + id] && (
            <div className="trtui-invalid-feedback">{errors['examStartTime-' + id].message}</div>
          )}
        </div>
        <div className={`trtui-col-md-3`}>
          <label className="trtui-form-label">End Time</label>
          <input
            className={`trtui-form-control ${errors['examEndTime-' + id] && 'trtui-is-invalid'}`}
            defaultValue={dayjs(exm.examSchedule?.examEndTime).format('HH:mm')}
            type="time"
            id={'examEndTime-' + id}
            {...register('examEndTime-' + id, {
              required: 'End time is required',
            })}
          />
          {errors['examEndTime-' + id] && (
            <div className="trtui-invalid-feedback">{errors['examEndTime-' + id].message}</div>
          )}
        </div>
        <div className={`trtui-col-md-3`}>
          <button
            className="trtui-btn trtui-btn-success trtui-btn-icon trtui-btn-sm"
            style={{ marginTop: '2.1rem' }}
          >
            <i className="ri ri-check-line" />
          </button>
        </div>
      </form>
    )
  }
}

ExamScheduleForm.propTypes = {
  onSubmit: PropTypes.func,
  onUpdate: PropTypes.func,
  id: PropTypes.number,
  exm: PropTypes.object,
  syl: PropTypes.object,
}
